export enum PdpActionEvents {
	ZOOM_OPEN = 'zoom_open',
}
